/* eslint-disable import/prefer-default-export */
export const SYSTEM = 'system';
export const VISITOR = 'visitor';
export const OPERATOR = 'operator';
export const TYPING = 'typing';
